/* tslint:disable */
/* eslint-disable */
/**
 * Modulos Platform API v2
 * API for the Modulos Platform.
 *
 * The version of the OpenAPI document: 2.5.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ProjectGraphLayer } from '../model';
// @ts-ignore
import type { ProjectGraphResponse } from '../model';
// @ts-ignore
import type { ProjectRiskFlowResponse } from '../model';
/**
 * ProjectGraphApi - axios parameter creator
 */
export const ProjectGraphApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Complete lightweight topology for one authorized project; rich details stay on entity endpoints.
         * @summary Get Project Graph
         * @param {string} projectId 
         * @param {Array<ProjectGraphLayer>} [include] Optional layers: tests and risks. Repeated or comma-separated values.
         * @param {boolean} [includeArchived] 
         * @param {boolean} [includeOutOfScope] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectGraph: async (projectId: string, include?: Array<ProjectGraphLayer>, includeArchived?: boolean, includeOutOfScope?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getProjectGraph', 'projectId', projectId)
            const localVarPath = `/projects/{project_id}/graph`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (include) {
                localVarQueryParameter['include'] = include;
            }

            if (includeArchived !== undefined) {
                localVarQueryParameter['include_archived'] = includeArchived;
            }

            if (includeOutOfScope !== undefined) {
                localVarQueryParameter['include_out_of_scope'] = includeOutOfScope;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Complete visible risk flow, using the latest quantified amounts and organization currency.  Null contributions are unknown; partial contributions are known subtotals. Values are not annualized and imply no control effectiveness or automatic risk reduction.
         * @summary Get Project Risk Flow
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectRiskFlow: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getProjectRiskFlow', 'projectId', projectId)
            const localVarPath = `/projects/{project_id}/risk-flow`
                .replace('{project_id}', encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProjectGraphApi - functional programming interface
 */
export const ProjectGraphApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProjectGraphApiAxiosParamCreator(configuration)
    return {
        /**
         * Complete lightweight topology for one authorized project; rich details stay on entity endpoints.
         * @summary Get Project Graph
         * @param {string} projectId 
         * @param {Array<ProjectGraphLayer>} [include] Optional layers: tests and risks. Repeated or comma-separated values.
         * @param {boolean} [includeArchived] 
         * @param {boolean} [includeOutOfScope] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectGraph(projectId: string, include?: Array<ProjectGraphLayer>, includeArchived?: boolean, includeOutOfScope?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectGraphResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectGraph(projectId, include, includeArchived, includeOutOfScope, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectGraphApi.getProjectGraph']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Complete visible risk flow, using the latest quantified amounts and organization currency.  Null contributions are unknown; partial contributions are known subtotals. Values are not annualized and imply no control effectiveness or automatic risk reduction.
         * @summary Get Project Risk Flow
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectRiskFlow(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectRiskFlowResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectRiskFlow(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectGraphApi.getProjectRiskFlow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProjectGraphApi - factory interface
 */
export const ProjectGraphApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProjectGraphApiFp(configuration)
    return {
        /**
         * Complete lightweight topology for one authorized project; rich details stay on entity endpoints.
         * @summary Get Project Graph
         * @param {ProjectGraphApiGetProjectGraphRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectGraph(requestParameters: ProjectGraphApiGetProjectGraphRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProjectGraphResponse> {
            return localVarFp.getProjectGraph(requestParameters.projectId, requestParameters.include, requestParameters.includeArchived, requestParameters.includeOutOfScope, options).then((request) => request(axios, basePath));
        },
        /**
         * Complete visible risk flow, using the latest quantified amounts and organization currency.  Null contributions are unknown; partial contributions are known subtotals. Values are not annualized and imply no control effectiveness or automatic risk reduction.
         * @summary Get Project Risk Flow
         * @param {ProjectGraphApiGetProjectRiskFlowRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectRiskFlow(requestParameters: ProjectGraphApiGetProjectRiskFlowRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProjectRiskFlowResponse> {
            return localVarFp.getProjectRiskFlow(requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getProjectGraph operation in ProjectGraphApi.
 */
export interface ProjectGraphApiGetProjectGraphRequest {
    readonly projectId: string

    /**
     * Optional layers: tests and risks. Repeated or comma-separated values.
     */
    readonly include?: Array<ProjectGraphLayer>

    readonly includeArchived?: boolean

    readonly includeOutOfScope?: boolean
}

/**
 * Request parameters for getProjectRiskFlow operation in ProjectGraphApi.
 */
export interface ProjectGraphApiGetProjectRiskFlowRequest {
    readonly projectId: string
}

/**
 * ProjectGraphApi - object-oriented interface
 */
export class ProjectGraphApi extends BaseAPI {
    /**
     * Complete lightweight topology for one authorized project; rich details stay on entity endpoints.
     * @summary Get Project Graph
     * @param {ProjectGraphApiGetProjectGraphRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProjectGraph(requestParameters: ProjectGraphApiGetProjectGraphRequest, options?: RawAxiosRequestConfig) {
        return ProjectGraphApiFp(this.configuration).getProjectGraph(requestParameters.projectId, requestParameters.include, requestParameters.includeArchived, requestParameters.includeOutOfScope, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Complete visible risk flow, using the latest quantified amounts and organization currency.  Null contributions are unknown; partial contributions are known subtotals. Values are not annualized and imply no control effectiveness or automatic risk reduction.
     * @summary Get Project Risk Flow
     * @param {ProjectGraphApiGetProjectRiskFlowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProjectRiskFlow(requestParameters: ProjectGraphApiGetProjectRiskFlowRequest, options?: RawAxiosRequestConfig) {
        return ProjectGraphApiFp(this.configuration).getProjectRiskFlow(requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }
}

